import * as Yup from 'yup';
import { ISignupPayload } from '@cincel/client';
import { translations } from 'translations';

export interface ISignupFormValuesProps extends Partial<ISignupPayload> {
  // We only require email for the new flow
  email: string;
}

export const SignupFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(translations.ERRORS.VALID_EMAIL),
});

export const DEFAULT_VALUES = {
  email: '',
  // Keep other fields as undefined/null or remove them if acceptable
  // ISignupPayload might require them, so we might need to cast or fix the type.
  // For now, let's just initialize what we use.
};
